// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nirx0zNIy737maGzaf74 {
    margin-top: 20px;
  }
  
  .ebjqR7vySQzrN3dq5Rhi {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .DXLC8CpQXcQfMYl8fjsc {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 300px;
    overflow-y: auto; 
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  
  
  .UaSSOe7pwiGrKdzelkAd {
    padding: 10px;
    margin-bottom: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    background-color: #ffffff;
    transition: background-color 0.3s, border-color 0.3s;
  }
  
  .UaSSOe7pwiGrKdzelkAd:hover {
    background-color: #f1f1f1;
  }
  
  .UaSSOe7pwiGrKdzelkAd:active {
    border-color: #007bff;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/SettingsWindow/HiddenFields.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;;;EAGA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,oDAAoD;EACtD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB","sourcesContent":[".hiddenFields {\n    margin-top: 20px;\n  }\n  \n  .inputField {\n    width: 100%;\n    padding: 8px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  .fieldList {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    max-height: 300px;\n    overflow-y: auto; \n    border: 1px solid #ddd;\n    border-radius: 5px;\n  }\n  \n  \n  .fieldItem {\n    padding: 10px;\n    margin-bottom: 5px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: #ffffff;\n    transition: background-color 0.3s, border-color 0.3s;\n  }\n  \n  .fieldItem:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .fieldItem:active {\n    border-color: #007bff;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hiddenFields": `Nirx0zNIy737maGzaf74`,
	"inputField": `ebjqR7vySQzrN3dq5Rhi`,
	"fieldList": `DXLC8CpQXcQfMYl8fjsc`,
	"fieldItem": `UaSSOe7pwiGrKdzelkAd`
};
export default ___CSS_LOADER_EXPORT___;
